<div class="klarna-checkout">
  <div>
      <iframe #klarnaIframe *ngIf="checkoutUrl" [style.height]="iframeHeight" [src]="checkoutUrl" ></iframe>
  </div>
</div>
